import { render, staticRenderFns } from "./updateModule.vue?vue&type=template&id=6eb5dd94&"
import script from "./updateModule.vue?vue&type=script&lang=ts&"
export * from "./updateModule.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports